import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';
import Footer from "../components/Footer";

function Thank() {
    useEffect(() => {
    window.scrollTo(0, 0)
    }, [])
    return (
        <>
        <div className="container thank-page p-5">
            <div className="row text-center d-flex thank-page_background justify-content-around">
                <h3 className="fa-fw-bolder">Muchas gracias por tu compra!</h3>
                <img src="/img/green_tick_simple.svg" alt="" className="green_tick mb-3"/>
                <p>Te estaremos notificando cuando tu orden esté lista para ser entregada</p>
                <p>Ver más información de la compra <Link to="/ordenes">Aquí</Link> </p>
            </div>
            <div className="row text-center p-3 d-flex justify-content-center mt-5">
                <h3 className="mt-3">Síguenos también en nuestras redes sociales</h3>
                <img src="/img/facebook.png" alt="" className="green_tick"/>
                <img src="/img/instagram.png" alt="" className="green_tick"/>
                <img src="/img/gorjeo.png" alt="" className="green_tick"/>
            </div>
        </div>
        <Footer/>
        </>
    )
}

export default Thank
